export default __webpack_public_path__ + "static/media/young, friendly, clean.df85d63c.png";